import Constantes from "@/enuns/Constantes";
import Swal from "sweetalert2";
import http from "@/http";
import ApiQueryEnum from "@/enuns/ApiQueryEnum";
import saveAs from "file-saver";
import moment from "moment";
import INormativo from "@/interfaces/INormativo";

type Main = {
  mark: (val: string, valueCompare: string) => string,
  markPartFile: (val: string, valueCompare: string) => string[],
  ajustarQuery: (queryTarget: string) => string,
  queryBuilder: (filtro: string, selectAdvancedTipoAto: string, inputAdvancedNumeroAto: string, inputAdvancedAnoAto: string,selectAdvancedTipoTema: string) => string,
  download: (format: string, ultimaPesquisa: string, methodConsulta: number) => void,
  isMobile: () => boolean,
  clearArray: (array: []) => void,
  dateFormat:(dateToFormat:string)=> string,
  isAllowed: (codigo:number) => boolean,
  stringFormat:(template: string, ...args: any[])=>string,
  getUriVisualizador:(id: string)=>string,
  consultarNormativo : (id: any) => Promise<INormativo>
}

export default (): Main => {

  const mark = (val: string, valueCompare: string) => {
    const defaltValueSize = 3; 
    valueCompare = removerFormatacaoPesquisa(valueCompare);
    if (valueCompare && valueCompare.trim().length >= defaltValueSize) {
      const split = valueCompare.split(' ');      
      if (split) {
        split.forEach((entry) => {   
          if(entry && entry.trim().length>= defaltValueSize){
          const regexExpression = new RegExp(entry, "gi");
          if (entry && entry.trim()) {           
            const result = new Map(
              val
                .match(regexExpression)
                ?.map((i) => [
                  i,
                  '<mark style="background-color: #FFFF00">' + i + "</mark>",
                ])
            );
            for (const [key, value] of result) {
              val = val.replace(key, value);
            }
          }
        }
        })
      }
     
    }
    return val;
  };

  const removerFormatacaoPesquisa = (value: string) => {  
    value = value.replaceAll('(','')
    value = value.replaceAll(')','')
    value = value.replaceAll('"','')
    value = value.replaceAll(Constantes.AND,' ');
    value = value.replaceAll(Constantes.OR,' ');
    value = value.replaceAll(Constantes.NOT,' ');
    value = value.replaceAll(Constantes.CODIGONORMA,'');
    value = value.replaceAll(Constantes.NUMERONORMA,'');
    value = value.replaceAll(Constantes.ANODOCUMENTO,'');
    return value;
  }

  const markPartFile = (val: string, valueCompare: string) => {
    const resultado: Array<string> = [];
    if (valueCompare && valueCompare.trim().length > 2) {
      const regexExpression = new RegExp(valueCompare, "gi");
      for (const match of val.matchAll(regexExpression)) {
        let rInicial: number | undefined = 0;
        let rFinal: number | undefined = 0;
        rInicial = (match?.index ? match.index : 0) - 300;
        rFinal = (match?.index ? match.index : 0) + 300;
        const textoExtraido = val?.substring(rInicial, rFinal);
        const textoMarcado = mark(textoExtraido, valueCompare);
        resultado.push(textoMarcado);
      }
    }
    return resultado;
  };

  const ajustarQuery = (queryTarget: string) => {
    if (queryTarget.charAt(0) != "(") {
      queryTarget = "(".concat(queryTarget);
    }
    if (
      queryTarget.charAt(queryTarget.trim().length - 1) != ")"
    ) {
      queryTarget = queryTarget.concat(")");
    }
    return queryTarget;
  };

  const queryBuilder = (patternSearch: string, selectAdvancedTipoAto: string, inputAdvancedNumeroAto: string, inputAdvancedAnoAto: string,selectAdvancedTipoTema: string) => {
    const queryBuilder = [];
    if (
      patternSearch &&
      patternSearch.length > 0  
    ) {
      patternSearch = patternSearch.trim();
      patternSearch = patternSearch.replaceAll(' e ', Constantes.AND);
      patternSearch = patternSearch.replaceAll(' ou ', Constantes.OR);
      patternSearch = patternSearch.replaceAll(' não ', Constantes.NOT);
      patternSearch = patternSearch.replaceAll(' nao ', Constantes.NOT);
      queryBuilder.push("(");
      queryBuilder.push(patternSearch);     
      queryBuilder.push(")");      
    }
    if (
      selectAdvancedTipoAto &&
      selectAdvancedTipoAto.length > 0
      ) {
        if (queryBuilder.length > 0) {
          queryBuilder.push(" ");
          queryBuilder.push(Constantes.AND);
          queryBuilder.push(" ");
        } 
      queryBuilder.push("(");
      queryBuilder.push("codigoNorma:");
      queryBuilder.push("\"");
      queryBuilder.push(selectAdvancedTipoAto);
      queryBuilder.push("\"");
      queryBuilder.push(")");
    }
    if (inputAdvancedNumeroAto) {
      if (queryBuilder.length > 0) {
        queryBuilder.push(" ");
        queryBuilder.push(Constantes.AND);
        queryBuilder.push(" ");
      } 
      queryBuilder.push("(");
      queryBuilder.push("numeroNorma:");
      queryBuilder.push(addLeadingZeros(inputAdvancedNumeroAto, 3));
      queryBuilder.push(")");
    }
    if (inputAdvancedAnoAto) {
      if (queryBuilder.length > 0) {
        queryBuilder.push(" ");
        queryBuilder.push(Constantes.AND);
        queryBuilder.push(" ");
      } 
      queryBuilder.push("(");
      queryBuilder.push("anoDocumento:");
      queryBuilder.push(inputAdvancedAnoAto);
      queryBuilder.push(")");
    }
    if (selectAdvancedTipoTema) {
      if (queryBuilder.length > 0) {
        queryBuilder.push(" ");
        queryBuilder.push(Constantes.AND);
        queryBuilder.push(" ");
      } 
      queryBuilder.push("(");
      queryBuilder.push("tema:");
      queryBuilder.push(selectAdvancedTipoTema);
      queryBuilder.push(")");
    }    
    console.log(queryBuilder.join(""))
    return queryBuilder.join("");
  };
  const download = async (format: string, ultimaPesquisa: string, methodConsulta: number) => {
    Swal.showLoading();
    await http
      .get(
        ApiQueryEnum.DOWNLOAD_RESULTADO.concat(ultimaPesquisa)
          .concat("&ff=")
          .concat(format)
          .concat("&mc=")
          .concat(methodConsulta.toString()),

        { responseType: "blob" }
      )
      .then((response: any) => {
        saveAs(response.data, "resultado.zip");
        Swal.close();
      });
  };

  const addLeadingZeros = (num: string, totalLength: number): string => {
    const formatado = String(num).padStart(totalLength, "0");
    return formatado;
  };
  const isMobile = (() => {
    if (screen.width <= 768) {      
      return true;
    }
    else {
      return false;
    }
  })
  const clearArray = ((array: [])=>{
    while (array.length > 0) {
      array.pop();
    }
  })

  const dateFormat=((dateToFormat:string)=>{
    return moment(dateToFormat).format(Constantes.DDMMYYYY);      
  });

  const isAllowed = ((codigo:number): boolean => {    
      
    return true;
  })

  const stringFormat = (template: string, ...args: any[]) => {
    console.log(args)
    return template.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
        ;
    });
  }; 

  const getUriVisualizador = ((id:string) => {
    if(id){
      return ApiQueryEnum.VISUALIZADOR_HTML + id;
    }
    return ApiQueryEnum.VISUALIZADOR + id;
  });

  const consultarNormativo = (id: any) => {
    const resultPromise = new Promise<INormativo>((resolve, reject) => {
      
      http
        .get(ApiQueryEnum.NORMATIVO+ id)
        .then((response) => {            
          const  normativo = response.data as INormativo;
          resolve(normativo);
        })
        .catch(() => {
          reject("erro na consulta");
        });
    });
    return resultPromise;
  };

  return {
    mark,
    markPartFile,
    ajustarQuery,
    queryBuilder,
    download,
    isMobile,
    clearArray,
    dateFormat,
    isAllowed,
    stringFormat,
    getUriVisualizador,
    consultarNormativo
  }

}
